<template>
  <v-row v-if="formulario">
    <v-col cols="12" v-if="!editing">
      <v-card tile flat outlined class="mx-1">
        <v-card-title>
          <p>Relatoria Oficina Intercâmbio Caravana e Encontro</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <span class="font-weight-bold text-uppercase">Atividade:</span>
              <span class="font-weight-bold title"> {{ formulario.atividade }}</span>
            </v-col>

            <v-col cols="4">
              <span class="font-weight-bold text-uppercase">Data:</span>
              <p class="font-weight-bold title"> {{ formulario.data ? formatDate(formulario.data) : '-' }} </p>
            </v-col>
            <v-col cols="4">
              <span class="font-weight-bold text-uppercase">Horário:</span>
              <p class="font-weight-bold title"> {{ formulario.horario }}</p>
            </v-col>
            <v-col cols="4">
              <span class="font-weight-bold text-uppercase">Facilitador:</span>
              <span class="font-weight-bold title"> {{ formulario.facilitador }}</span>
            </v-col>

            <v-col cols="12">
              <span class="font-weight-bold text-uppercase">Local:</span>
              <span class="font-weight-bold title"> {{ formulario.local }}</span>
            </v-col>

            <v-col cols="6">
              <span class="font-weight-bold text-uppercase">Número de Mulheres:</span>
              <span class="font-weight-bold title"> {{ formulario.totalMulheres }}</span>
            </v-col>
            <v-col cols="6">
              <span class="font-weight-bold text-uppercase">Número de Homens:</span>
              <span class="font-weight-bold title"> {{ formulario.totalHomens }}</span>
            </v-col>

            <v-col cols="12">
              <span class="font-weight-bold text-uppercase">Grupos:</span>
              <span class="font-weight-bold title"> {{ formulario.grupos }}</span>
            </v-col>

            <v-col cols="12">
              <span class="font-weight-bold text-uppercase">Síntese:</span>
              <span class="font-weight-bold title"> {{ formulario.sintese }}</span>
            </v-col>

            <v-col cols="12">
              <span class="font-weight-bold text-uppercase">Alcance dos objetivos:</span>
              <span class="font-weight-bold title"> {{ formulario.alcanceObjetivos }}</span>
            </v-col>

            <v-col cols="12">
              <span class="font-weight-bold text-uppercase">Pontos fracos:</span>
              <span class="font-weight-bold title"> {{ formulario.pontosFracos }}</span>
            </v-col>

            <v-col cols="12">
              <span class="font-weight-bold text-uppercase">Dificuldades encontradas & Soluções adotadas:</span>
              <span class="font-weight-bold title"> {{ formulario.dificuldadeSolucao }}</span>
            </v-col>

            <v-col cols="12">
              <span class="font-weight-bold text-uppercase">Recomendações:</span>
              <span class="font-weight-bold title"> {{ formulario.recomendacoes }}</span>
            </v-col>

          </v-row>
        </v-card-text>
        <v-card-actions class="ml-1 mb-3" v-if="permissao">
          <v-btn @click.prevent="editing = true"  color="primary text-center" small>Editar</v-btn>
          <v-btn @click="excluir" color="error text-center" :disabled="formulario.arquivos.length > 0" small>Excluir</v-btn>
          <Confirm ref="confirm"></Confirm>
        </v-card-actions>
        <v-divider></v-divider>
        <Arquivo :permissao="permissao" :lancamento="lancamento" :formulario="formulario"  :urlFormulario="url"></Arquivo>
      </v-card>
    </v-col>
    <FormularioEditor v-else
      :formulario="formulario"
      :permissao="permissao"
      @save="editing = false"
      @cancel="editing = false" />
  </v-row>
  <v-row v-else>
    <FormularioEditor
      :lancamento="lancamento"
      :permissao="permissao"
      @save="editing = false"
      @cancel="editing = false" />
  </v-row>
</template>

<script>
const fileIcons = {
    zip: "mdi-folder-zip-outline",
    rar: "mdi-folder-zip-outline",
    htm: "mdi-language-html5",
    html: "mdi-language-html5",
    js: "mdi-nodejs",
    json: "mdi-json",
    md: "mdi-markdown",
    pdf: "mdi-file-pdf",
    png: "mdi-file-image",
    jpg: "mdi-file-image",
    jpeg: "mdi-file-image",
    mp4: "mdi-filmstrip",
    mkv: "mdi-filmstrip",
    avi: "mdi-filmstrip",
    wmv: "mdi-filmstrip",
    mov: "mdi-filmstrip",
    txt: "mdi-file-document-outline",
    xls: "mdi-file-excel",
    other: "mdi-file-outline"
};

import { formatBytes } from "../../Arquivo/util";
import FormularioEditor from "./RelatoriaOficinaIntercambioCaravanaEditor";
import Confirm from "@/components/Dialog/Confirm";
import Arquivo from "@/pages/Projeto/components/Arquivo/Arquivo"
import { mapActions } from "vuex";

export default {
  components: {
    FormularioEditor,
    Arquivo,
    Confirm,
  },
  props: {
    lancamento: {
      require: true
    },
    permissao: {
      require: false
    },
    icons: { type: Object, default: () => fileIcons },
  },
  computed: {
    formulario() {
      return this.$store.getters["formulario/byLancamentoIdAndTipo"](this.lancamento.id, 'RELATORIA_OFICINA_INTERCAMBIO_CARAVANA');
    }
  },
  data () {
    return {
      editing: false,
      files: [],
      url: '/relatoria-oficina-intercambio-caravana'
    }
  },

  methods: {
    formatBytes,

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    ...mapActions("formulario", ["deleteFormulario", "upload", "downloadArquivo", "deleteArquivo"]),

    excluir() {
      this.$refs.confirm.open('Excluir Relatoria Oficina Intercâmbio Caravana e Encontro', '', "Você tem certeza?", this.optionsExcluir)
        .then((confirm) => {
          if (confirm) {
            const payload = {
              "indicadorId": this.lancamento.indicador.id,
              "lancamentoId": this.lancamento.id,              
              'formularioId': this.formulario.id,
              'formulario': this.formulario,
              'urlFormulario': this.url
            };

            this.deleteFormulario(payload);
          }
        });
    },

    adicionarArquivos() {
      console.log('this.files ', Object.values(this.files))
      const payload = {
        "indicadorId": this.lancamento.indicador.id,
        "lancamentoId": this.lancamento.id,              
        'formularioId': this.formulario.id,
        'urlFormulario': this.url,
        'files': Object.values(this.files)
      };
      
      this.upload(payload).then(() => {
        this.files = [] 
      });

    },

    downloadItem(item) {
      const payload = {
        "indicadorId": this.lancamento.indicador.id,
        "lancamentoId": this.lancamento.id,
        'arquivoId': item.id
      }
      this.downloadArquivo(payload)
    },
    
    deleteItem(item) {
      const payload = {
        "indicadorId": this.lancamento.indicador.id,
        "lancamentoId": this.lancamento.id,              
        'formularioId': this.formulario.id,
        'urlFormulario': this.url,
        'arquivoId': item.id
      }
      this.deleteArquivo(payload)
    }
  }
};
</script>

<style>
</style>